import React from 'react';
import { motion } from 'framer-motion';
import { Search, SlidersHorizontal, Sparkles } from 'lucide-react';
import { Reveal } from '../Reveal';
import { TalabChapterFrame } from './TalabChapterFrame';
import { NOVA_PRODUCTS } from '../../../data/talabProducts';
const EASE = [0.23, 1, 0.32, 1] as const;
const GRID_PRODUCTS = [NOVA_PRODUCTS[0], NOVA_PRODUCTS[1], NOVA_PRODUCTS[2], NOVA_PRODUCTS[3], NOVA_PRODUCTS[4], NOVA_PRODUCTS[0]];
const RECOMMENDATIONS = [NOVA_PRODUCTS[0], NOVA_PRODUCTS[1], NOVA_PRODUCTS[2]];
const FILTERS = ['Size 43', 'Cushioned', 'Under AED 600', 'Neutral', '+8 more'];
const TRANSFORMS = [{
  from: 'Search',
  to: 'Ask'
}, {
  from: 'Filter',
  to: 'Understand'
}, {
  from: 'Browse',
  to: 'Recommend'
}];
function LegacyStore() {
  return <div className="overflow-hidden rounded-2xl border border-slate-900/[0.08] bg-white shadow-[0_20px_46px_-24px_rgba(15,23,42,0.28)]" data-id="element-946" data-mp="kix5hma7508d">
      {/* Chrome */}
      <div className="flex items-center gap-[8px] border-b border-slate-900/[0.06] bg-slate-50 px-[12px] py-[8px]" data-id="element-947" data-mp="pfwzgytrucj4">
        <span className="h-[6px] w-[6px] rounded-full bg-slate-300" data-id="element-948" data-mp="ppgderjy919h" />
        <span className="h-[6px] w-[6px] rounded-full bg-slate-300" data-id="element-949" data-mp="lra9rseer1ss" />
        <span className="h-[6px] w-[6px] rounded-full bg-slate-300" data-id="element-950" data-mp="gq35427kaiqc" />
        <span className="ml-[6px] rounded-md bg-white px-[9px] py-[2px] text-[8.5px] font-medium text-slate-500 ring-1 ring-slate-900/[0.06]" data-id="element-951" data-mp="brrvnsl6ia8n">
          novasport.com/running
        </span>
      </div>

      {/* Search + nav */}
      <div className="border-b border-slate-900/[0.05] px-[14px] py-[10px]" data-id="element-952" data-mp="21q60wd6gjrm">
        <div className="flex items-center gap-[8px] rounded-lg border border-slate-900/[0.08] px-[10px] py-[6px]" data-id="element-953" data-mp="3u5iz8rlmvcgq">
          <Search className="h-[11px] w-[11px] text-slate-400" data-id="element-954" data-mp="3p77ngbbs2rvv" />
          <span className="text-[10.5px] text-slate-600" data-id="element-955" data-mp="3p4uwj8o1l76o">running shoes</span>
        </div>
        <div className="mt-[9px] flex items-center gap-[7px] text-[9px] text-slate-400" data-id="element-956" data-mp="3k9pc6eaag0kp">
          <span data-id="element-957" data-mp="3f9a0dr5nn14u">Home</span>
          <span data-id="element-958" data-mp="35kw1rajpzo4j">›</span>
          <span data-id="element-959" data-mp="35kcsei84y824">Men</span>
          <span data-id="element-960" data-mp="35k4j10b81kvo">›</span>
          <span data-id="element-961" data-mp="35mz2aoii0zni">Shoes</span>
          <span data-id="element-962" data-mp="3ajz58qk1xmae">›</span>
          <span className="font-semibold text-slate-700" data-id="element-963" data-mp="3ak8yqo4b2bku">Running</span>
        </div>
      </div>

      {/* Filters */}
      <div className="flex items-center gap-[6px] border-b border-slate-900/[0.05] px-[14px] py-[9px]" data-id="element-964" data-mp="2wlj219leedx0">
        <SlidersHorizontal className="h-[10px] w-[10px] text-slate-400" data-id="element-965" data-mp="30mkvtawjpxrl" />
        {FILTERS.map(filter => <span key={filter} className="rounded-full border border-slate-900/[0.08] bg-slate-50 px-[8px] py-[3px] text-[8.5px] font-medium text-slate-500" data-id="element-966" data-mp="3oc5oilii49e2">
            {filter}
          </span>)}
      </div>

      <div className="flex items-center justify-between px-[14px] pt-[9px] text-[8.5px] text-slate-400" data-id="element-967" data-mp="3jk5h6803qe7g">
        <span data-id="element-968" data-mp="b4lszneaflz9">248 results</span>
        <span data-id="element-969" data-mp="b3aqrs0hqma9">Sort: Popular</span>
      </div>

      {/* Product grid */}
      <div className="grid grid-cols-3 gap-[9px] px-[14px] pb-[14px] pt-[8px]" data-id="element-970" data-mp="fvu0uezyyzab">
        {GRID_PRODUCTS.map((product, index) => <div key={`${product.id}-${index}`} className="overflow-hidden rounded-lg border border-slate-900/[0.06]" data-id="element-971" data-mp="20k69dhteyrzc" data-mpi={index}>
            <img src={product.image} alt={product.name} className="h-[62px] w-full object-cover" data-id="element-972" data-mp="2acby8iodctab" />
            <div className="px-[7px] py-[6px]" data-id="element-973" data-mp="25dhg7iy878r9">
              <div className="truncate text-[8.5px] font-medium text-slate-700" data-id="element-974" data-mp="1hmlmgga7m3hd">
                {product.name}
              </div>
              <div className="mt-[2px] text-[8.5px] font-semibold text-slate-900" data-id="element-975" data-mp="1cpld9wi2ckm1">
                {product.price}
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}
function TalabConversation() {
  return <div className="overflow-hidden rounded-2xl border border-slate-900/[0.08] bg-white shadow-[0_30px_70px_-30px_rgba(15,23,42,0.35)]" data-id="element-976" data-mp="330gajn1g44lz">
      {/* Header */}
      <div className="flex items-center justify-between border-b border-slate-900/[0.06] px-[20px] py-[13px]" data-id="element-977" data-mp="2y0vb7bid5u8q">
        <div className="flex items-center gap-[13px]" data-id="element-978" data-mp="17mcgf68w55aj">
          <span className="text-[13px] font-semibold tracking-[0.26em] text-slate-900" data-id="element-979" data-mp="1ciksubvpeke0">
            TALAB
          </span>
          <span className="h-[12px] w-px bg-slate-200" data-id="element-980" data-mp="1gjeeeylobn3q" />
          <span className="text-[11px] font-light text-slate-500" data-id="element-981" data-mp="1lkk7wyn5reeb">
            Nova Sportswear
          </span>
        </div>
        <span className="flex items-center gap-[6px] text-[9px] font-semibold uppercase tracking-[0.16em] text-vexu-700" data-id="element-982" data-mp="1qi2lx3g18jt6">
          <span className="h-[5px] w-[5px] rounded-full bg-vexu" data-id="element-983" data-mp="1vgdtf7iuui88" />
          Live
        </span>
      </div>

      <div className="px-[20px] py-[18px]" data-id="element-984" data-mp="209qdr5gi42v6">
        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.3
      }} className="flex justify-end" data-id="element-985" data-mp="24b1vypx1pltc">
          <span className="max-w-[70%] rounded-2xl rounded-br-md bg-slate-100 px-[15px] py-[11px] text-[13.5px] leading-[1.45] text-slate-800" data-id="element-986" data-mp="2e9ri4uvz5sfe">
            I need running shoes for marathon training under AED 600.
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.44
      }} className="mt-[12px] flex items-start gap-[10px]" data-id="element-987" data-mp="2jfwlt6vosmxt">
          <span className="mt-[3px] grid h-[24px] w-[24px] flex-shrink-0 place-items-center rounded-full bg-vexu/12" data-id="element-988" data-mp="373e7ckocyosc">
            <Sparkles className="h-[12px] w-[12px] text-vexu-700" data-id="element-989" data-mp="325cnhxj3ylft" />
          </span>
          <span className="max-w-[78%] rounded-2xl rounded-bl-md border border-vexu/25 bg-vexu/[0.06] px-[15px] py-[11px] text-[13.5px] leading-[1.45] text-slate-800" data-id="element-990" data-mp="2xc9rliquyzwg">
            I found three strong options. This one offers the best cushioning
            for long-distance training.
          </span>
        </motion.div>

        {/* Recommendations */}
        <div className="mt-[16px] grid grid-cols-3 gap-[12px]" data-id="element-991" data-mp="3l12uy09t8a13">
          {RECOMMENDATIONS.map((product, index) => <motion.div key={product.id} initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.32,
          ease: EASE,
          delay: 0.56 + index * 0.09
        }} className={`overflow-hidden rounded-xl border bg-white ${index === 0 ? 'border-vexu/45 shadow-[0_16px_34px_-18px_rgba(0,200,83,0.5)]' : 'border-slate-900/[0.07]'}`} data-id="element-992" data-mp="1o46rmvc26i5r" data-mpi={index}>
              <img src={product.image} alt={product.name} className="h-[112px] w-full object-cover" data-id="element-993" data-mp="qiiw0cnfg3va" />
              <div className="px-[12px] pb-[12px] pt-[10px]" data-id="element-994" data-mp="2kvs9sgn0abjc">
                <div className="text-[12.5px] font-semibold tracking-[-0.01em] text-slate-900" data-id="element-995" data-mp="2pttqiuwylyrn">
                  {product.name}
                </div>
                <div className="mt-[3px] text-[12px] font-medium text-slate-500" data-id="element-996" data-mp="e78cb31bcoiu">
                  {product.price}
                </div>
                <span className={`mt-[9px] inline-block rounded-full px-[9px] py-[4px] text-[9px] font-semibold uppercase tracking-[0.12em] ${index === 0 ? 'bg-vexu text-white' : 'border border-slate-900/[0.09] text-slate-500'}`} data-id="element-997" data-mp="95j2fqptugwc">
                  {product.reason}
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.86
      }} className="mt-[16px] flex items-center gap-[10px] rounded-full border border-slate-900/[0.08] bg-slate-50 px-[15px] py-[10px]" data-id="element-998" data-mp="16ucnxquww13l">
          <span className="h-[5px] w-[5px] rounded-full bg-vexu" data-id="element-999" data-mp="33pik6fd3mje0" />
          <span className="text-[11.5px] text-slate-400" data-id="element-1000" data-mp="2ht73o5ni6p9c">
            Which one lasts longest on hard pavement?
          </span>
        </motion.div>
      </div>
    </div>;
}
interface TalabShiftSlideProps {
  onExit: () => void;
}
export function TalabShiftSlide({
  onExit
}: TalabShiftSlideProps) {
  return <TalabChapterFrame onExit={onExit} data-id="element-1001" data-mp="2wilgxou79qu0">
      <Reveal delay={0} data-id="element-1002" data-mp="1yve49dc38xgp">
        <h2 className="text-[38px] font-semibold leading-[1.08] tracking-[-0.03em] text-slate-900" data-id="element-1003" data-mp="1yw5zuo5oqv6z">
          E-Commerce Is Entering the Conversational Era
        </h2>
      </Reveal>

      <div className="mt-[26px] flex items-start gap-[24px]" data-id="element-1004" data-mp="28tttfark1wnk">
        {/* Today */}
        <Reveal delay={0.08} className="w-[476px]" data-id="element-1005" data-mp="2dsna1c2523ry">
          <div className="mb-[12px] flex items-center justify-between" data-id="element-1006" data-mp="2dtetjoigob1v">
            <span className="text-[10px] font-semibold uppercase tracking-[0.26em] text-slate-400" data-id="element-1007" data-mp="3k98uoqqsraoh">
              Navigate to Find
            </span>
            <span className="text-[10px] font-light text-slate-400" data-id="element-1008" data-mp="3p9wspwdg0rs7">
              Today&rsquo;s best e-commerce
            </span>
          </div>
          <LegacyStore data-id="element-1009" data-mp="18ku89f4w385k" />
        </Reveal>

        {/* Transformation */}
        <Reveal delay={0.3} className="w-[150px] pt-[64px]" data-id="element-1010" data-mp="13unkfhi7brod">
          <div className="space-y-[20px]" data-id="element-1011" data-mp="13t2pvrvw08qi">
            {TRANSFORMS.map((item, index) => <motion.div key={item.from} initial={{
            opacity: 0,
            x: -6
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.3,
            ease: EASE,
            delay: 0.34 + index * 0.1
          }} className="text-center" data-id="element-1012" data-mp="yurbd3unda1y" data-mpi={index}>
                <div className="text-[12px] font-light uppercase tracking-[0.16em] text-slate-300 line-through" data-id="element-1013" data-mp="fx80rvsjjjdf">
                  {item.from}
                </div>
                <div className="mx-auto my-[6px] h-[14px] w-px bg-gradient-to-b from-slate-200 to-vexu/50" data-id="element-1014" data-mp="2f7g9ulnis419" />
                <div className="text-[14px] font-semibold uppercase tracking-[0.16em] text-vexu-700" data-id="element-1015" data-mp="2hmu30wolkarm">
                  {item.to}
                </div>
              </motion.div>)}
          </div>
        </Reveal>

        {/* Conversational hero */}
        <Reveal delay={0.16} className="flex-1" data-id="element-1016" data-mp="2qmyzwcw5zqrj">
          <div className="mb-[12px] flex items-center justify-between" data-id="element-1017" data-mp="2mm6phgbk3fto">
            <span className="text-[10px] font-semibold uppercase tracking-[0.26em] text-vexu-700" data-id="element-1018" data-mp="2mjsypjnwsprx">
              Just Ask
            </span>
            <span className="text-[10px] font-light text-slate-400" data-id="element-1019" data-mp="1ty12emx15eqo">
              Conversational commerce
            </span>
          </div>
          <TalabConversation data-id="element-1020" data-mp="27pxr0gzhp6ib" />
        </Reveal>
      </div>

      <div className="flex-1" data-id="element-1021" data-mp="22xo4laxl2oks" />

      <Reveal delay={0.9} data-id="element-1022" data-mp="22wd53nb682zh">
        <div className="h-px w-full bg-slate-900/[0.10]" data-id="element-1023" data-mp="22w3a1lb9r5mx" />
        <div className="flex items-end justify-between pt-[20px]" data-id="element-1024" data-mp="1f70tkgsdfiu0">
          <p className="max-w-[760px] text-[21px] font-light leading-[1.4] tracking-[-0.015em] text-slate-500" data-id="element-1025" data-mp="1b79zo47jsml9">
            Customers are learning to{' '}
            <span className="font-medium text-slate-900" data-id="element-1026" data-mp="110qi3tjjznww">
              express what they want
            </span>{' '}
            — not navigate to find it.
          </p>
          <span className="whitespace-nowrap pb-[2px] text-[11px] font-semibold uppercase tracking-[0.24em] text-slate-400" data-id="element-1027" data-mp="r5yk4om26z1l">
            Next → Meet Talab
          </span>
        </div>
      </Reveal>
    </TalabChapterFrame>;
}